<template>
    <div class="main-page">
        <template v-if="showHeader">
            <section class="page-section " >
                <div class="container-fluid">
                    <div class="grid justify-content-between">
                        <div class="col " >
                            <div class="">
                                <div class=" text-2xl text-primary font-bold" >
                                    Edit User Permissions
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <hr />
        </template>
        <section class="page-section pt-3" >
            <div class="container-fluid">
                <div class="grid ">
                    <div class="md:col-9 sm:col-12 comp-grid" >
                        <div class="">
                            <div class="">
                                <div >
                                    <template v-if="pageReady">
                                        <div class="grid">
                                            <div class="col-12">
                                                <form ref="observer"  tag="form" @submit.prevent="submitForm()" class="" :class="{ 'card': !isSubPage }">
                                                    <!--[form-content-start]-->
                                                    <div class="grid">
                                                        <div class="col-12">
                                                            Permission *
                                                            <div id="ctrl-permission-holder"> 
                                                                <InputText ref="ctrlpermission" v-model.trim="formData.permission"  label="Permission" type="text" placeholder="Enter Permission"      
                                                                class=" w-full" :class="getErrorClass('permission')">
                                                                </InputText>
                                                                <small v-if="isFieldValid('permission')" class="p-error">{{ getFieldError('permission') }}</small> 
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            Role Id 
                                                            <div id="ctrl-role_id-holder"> 
                                                                <api-data-source   api-path="components_data/role_id_option_list" >
                                                                    <template v-slot="req">
                                                                        <Dropdown class="w-full" :class="getErrorClass('role_id')"   :loading="req.loading"   optionLabel="label" optionValue="value" ref="ctrlrole_id"  v-model="formData.role_id" :options="req.response" label="Role Id"  placeholder="Select a value ..." >
                                                                        </Dropdown> 
                                                                        <small v-if="isFieldValid('role_id')" class="p-error">{{ getFieldError('role_id') }}</small> 
                                                                    </template>
                                                                </api-data-source>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!--[form-content-end]-->
                                                    <div v-if="showSubmitButton" class="text-center my-3">
                                                        <Button type="submit" label="Update" class=" p-button-rounded" icon="pi pi-send" :loading="saving" />
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="loading">
                                        <div class="p-3 text-center">
                                            <ProgressSpinner style="width:50px;height:50px" />
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
	import {  computed,  reactive, toRefs, onMounted } from 'vue';
	import useVuelidate from '@vuelidate/core';
	import { required, numeric, } from '@/services/validators';
	import { useApp } from '@/composables/app.js';
	import { useEditPage } from '@/composables/editpage.js';
	const props = defineProps({
		id: [String, Number],
		pageName: {
			type: String,
			default: 'user_permissions',
		},
		routeName: {
			type: String,
			default: 'user_permissionsedit',
		},
		pagePath: {
			type : String,
			default : 'user_permissions/edit',
		},
		apiPath: {
			type: String,
			default: 'user_permissions/edit',
		},
		submitButtonLabel: {
			type: String,
			default: "Update",
		},
		formValidationError: {
			type: String,
			default: "Form is invalid",
		},
		formValidationMsg: {
			type: String,
			default: "Please complete the form",
		},
		msgAfterUpdate: {
			type: String,
			default: "Record updated successfully",
		},
		showHeader: {
			type: Boolean,
			default: true,
		},
		showSubmitButton: {
			type: Boolean,
			default: true,
		},
		redirect: {
			type : Boolean,
			default : true,
		},
		isSubPage: {
			type : Boolean,
			default : false,
		},
	});
	const app = useApp();
	const formDefaultValues = Object.assign({
		permission: "", 
		role_id: "", 
	}, props.pageData);
	const formData = reactive({ ...formDefaultValues });
	function onFormSubmited(response) {
		app.flashMsg(props.msgAfterUpdate);
		if(props.redirect) app.navigateTo(`/user_permissions`);
	}
	const rules = computed(() => {
		return {
			permission: { required },
			role_id: { numeric }
		}
	});
	const v$ = useVuelidate(rules, formData); //form validation
	const page = useEditPage(props, formData, v$, onFormSubmited);
	//page state
	const {
		submitted, // form api submitted state - Boolean
		saving, // form api submiting state - Boolean
		loading, // form data loading state - Boolean
		pageReady, // if api data loaded successfully
	} = toRefs(page.state);
	//page computed propties
	const {
		apiUrl, // page current api path
		currentRecord, // current page record  - Object
	} = page.computedProps
	//page methods
	const { 
		load, // get editable form data from api
		submitForm, // submit form data to api
		getErrorClass, // return error class if field is invalid- args(fieldname)
		getFieldError, //  get validation error message - args(fieldname)
		isFieldValid, // check if field is validated - args(fieldname)
		 // map api datasource  to Select options label-value
	} = page.methods;
	onMounted(()=>{
		const pageTitle = "Edit User Permissions";
		app.setPageTitle(props.routeName, pageTitle); // set browser page title
		load();
	});
</script>
<style scoped>
</style>
